import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface OnboardingStepperProps {
  /** total number of visible steps (4 for COM-650's wizard) */
  total: number;
  /** 1-based index of the active step */
  current: number;
}

export function OnboardingStepper({ total, current }: OnboardingStepperProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="caption">{`Step ${current} of ${total}`}</Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {Array.from({ length: total }, (_, i) => (
          <Box
            key={i}
            sx={{
              height: 4,
              flex: 1,
              borderRadius: 2,
              backgroundColor: i < current ? '#0E0E0E' : '#DEDEDE',
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
